<template>
    <v-container fluid style="flex: 1; height: 94%; align-self: center">
        <v-row justify="center" align="center" style="height: 100%;">
            <v-col cols="3">
                <v-img :src="imageSource" :width="500" />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
const image = require('@/assets/404.svg')
export default {
  name: 'NotFound',
  computed: {
    imageSource () {
      return image
    }
  }
}
</script>

<style scoped>

</style>
